import { Route, Routes, useLocation } from 'react-router-dom';
import HP from './routes/HP';
import Layout from './routes/Layout';
import { useEffect, useState } from 'react';
import { useLenis } from '@studio-freight/react-lenis';
import Karty from './routes/Karty';
import Workshop from './routes/Workshop';

const Router = () => {
    return (
        <Layout language={'cs'} >
            <Routes>
              <Route exact path="/" element={<HP />} /> 
              <Route exact path="/karty" element={<Karty />} /> 
              <Route exact path="/workshop" element={<Workshop />} /> 
            </Routes>
        </Layout>
    )
}

export default Router;